module.exports = __webpack_public_path__ + "img/rankinprogress.391869d0.png";